// extracted by mini-css-extract-plugin
export default {"parent":"MainNav_parent__OWnKM","active":"MainNav_active__onkhO","default":"MainNav_default__hXE0u"};